import React, {useEffect, useRef, useState} from "react";
import {css} from "@emotion/react";

interface IProps {
    children: ((height: number) => React.ReactNode) | React.ReactNode;
    className?: string;
}

export const Row = (props: IProps) => {
    const {children, className} = props;
    const rowRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState(rowRef.current ? rowRef.current.offsetHeight : 0);

    useEffect(() => {
        if (window && "ResizeObserver" in window && rowRef.current) {
            const resizeObserver = new ResizeObserver((entries) => {
                const entryRect = entries[0].contentRect;
                setHeight(entryRect.height);
            });

            resizeObserver.observe(rowRef.current);
        }
    }, []);

    return (
        <div ref={rowRef} css={row} className={className}>
            {typeof children === "function" ? children(height) : children}
        </div>
    );
};

const row = css`
    display: flex;
`;
import React, {useEffect, useRef, useState} from "react";
import {css} from "@emotion/react";

interface IProps {
    children: ((height: number) => React.ReactNode) | React.ReactNode;
    className?: string;
}

export const Row = (props: IProps) => {
    const {children, className} = props;
    const rowRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState(rowRef.current ? rowRef.current.offsetHeight : 0);

    useEffect(() => {
        if (window && "ResizeObserver" in window && rowRef.current) {
            const resizeObserver = new ResizeObserver((entries) => {
                const entryRect = entries[0].contentRect;
                setHeight(entryRect.height);
            });

            resizeObserver.observe(rowRef.current);
        }
    }, []);

    return (
        <div ref={rowRef} css={row} className={className}>
            {typeof children === "function" ? children(height) : children}
        </div>
    );
};

const row = css`
    display: flex;
`;
